import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, borderRadius } = useTheme();

  return {
    middlePart: (MQtoHideQuickLinks) => css`
      ${breakpoints.mm_xl_xxl} {
        padding-top: 0rem;
        margin-top: 3rem;
      }
      ${breakpoints.mm_l_xl} {
        padding-top: 0rem;
        margin-top: 3rem;
      }
      ${breakpoints.mm_m_l} {
        padding-top: 0px;
        margin-top: 0rem;
      }
      ${breakpoints.mm_s_m} {
        padding-top: 32px;
      }
      ${breakpoints.mm_xs_s} {
        padding-top: 0px;
        // margin-top: 10rem;
        // if not MQtoHideQuickLinks, then above margin
      }
      ${MQtoHideQuickLinks && css`
        margin-top: -0.5rem;
      `}
    `,
    title: css`
      display: inline-block;
      font-size: 1.62rem;
      color: ${colors.navy};
      margin: ${spacing.xs} 0 -12px;
      font-family: 'FS Dillon Bold';
      font-style: normal;
      line-height: 2rem;

      ${breakpoints.m} {
        color: ${colors.navy};
        line-height: 2.62rem;
      }
      ${breakpoints.l} {
        font-style: normal;
        text-decoration: none;
        font-weight: 700;
        letter-spacing: 0.0018em;
        font-size: 2.22125rem;
      }
      ${breakpoints.mm_m_l} {
        margin: ${spacing.xs} 0 -4px;
      }
      ${breakpoints.mm_s_m} {
        margin: ${spacing.xs} 0 -3px;
      }
      ${breakpoints.mm_xs_s} {
        margin: ${spacing.xs} 0 -4px;
      }
    `,
    top: css`
      display: flex;
      gap: 0.5rem;
      margin-bottom: 16px;
      justify-content: space-between;
      @media (min-width: 767px) and (max-width: 768px) {
        flex-direction: column-reverse;
      }
      @media (min-width: 269px) and (max-width: 766px) {
        flex-direction: column-reverse;
      }
    `,
    moreInfo: hasMoreInfo => css`
      display: flex;
      justify-content: center;
      color: ${colors.white};
      text-transform: capitalize;

      > :first-of-type {
        margin-right: ${spacing.s};
        font-size: 0.875rem;

        ${breakpoints.l} {
          font-size: ${spacing.s};
        }
      }

      ${breakpoints.l} {
        display: grid;
        width: 40%;
        margin: 0 auto;

        ${hasMoreInfo &&
        css`
          grid-auto-flow: column;
          grid-template-columns: auto auto;
        `}
      }
    `,
    imageWrap: css`
      position: relative;
      height: 26px;
      width: 97px;
      margin-top: 15px;
    `,
    textWrapper: css`
      color: ${colors.white};
      padding: 6rem ${spacing.s} 1.5rem 1.5rem;

      h3 {
        margin-bottom: 0.3rem;
        color ${colors.navy};
      }

      button {
        background-color: ${colors.red};
        color: ${colors.white};
        max-width: 11rem;
        margin-top: ${spacing.s};
      }
      
      ${breakpoints.l}{
        padding: ${spacing.s} ${spacing.s} 1.5rem ${spacing.xl};
      }
    `,
    imgWrapper: css`
      position: relative;
      padding-top: ${spacing.s};
      // EF-2523 - remove ads
      display: none;
    `,
    imgContent: css`
      background: url(/images/common/partner-promo-mobile.jpg) 0 0 no-repeat;
      border-radius: ${borderRadius.l};

      ${breakpoints.m} {
        background: url(/images/common/partner-promo.jpg) 0 0 no-repeat;
        min-height: 14.1875rem;
        background-size: cover;
        display: grid;
        align-content: end;
        width: 100%;
      }
    `,
    middle: isprovider => css`
      padding-top: ${spacing.xs};
      display: grid;
      grid-gap: ${spacing.xl};
      max-width: 951px;
      margin: 0 auto;
      ${isprovider &&
      css`
        grid-template-columns: repeat(auto-fill, minmax(186px, 1fr));
      `}

      ${breakpoints.l} {
        grid-template-columns: auto max(325px);
      }
    `,
    clubDescriptionWrapper: css`
      p {
        font-size: ${spacing.s};
        padding-bottom: 1.5rem;
        line-height: 1.375rem;
        letter-spacing: 0.02em;
        color: ${colors.darkGrey};
      }

      a {
        display: inline-block;
        color: ${colors.darkGrey};
      }
    `,
    clubFacilitiesWrapper: css`
      padding: ${spacing.xs} 0;
      margin-top: ${spacing.s};

      ${breakpoints.m} {
        padding: ${spacing.xs} 0;
        margin-top: 0.1rem;
      }
    `,
    group: css`
      display: grid;
      grid-template-columns: auto;
      grid-gap: 8px;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #eceef3;
      // &:last-child {
      //   border-bottom: none;
      // }
    `,
    groupLabel: css`
      font-size: 15px;
      font-weight: 700;
      color: #011e41;
      line-height: 20px;
      text-transform: uppercase;
      letter-spacing: 0.08em;
      font-family: 'FS Dillon Bold';
    `,
    groupValue: css`
      font-size: 16px;
      color: ${colors.next_grey};
      line-height: 20px;
      letter-spacing: 0.02em;
      display: flex;
      gap: 4px;
      flex-wrap: wrap;
    `,
  };
};
